export default "__VITE_ASSET__BWPeWrNx__"